import { render, staticRenderFns } from "./OccurrenceMessages.vue?vue&type=template&id=8f761d96&scoped=true&"
import script from "./OccurrenceMessages.vue?vue&type=script&lang=js&"
export * from "./OccurrenceMessages.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceMessages.vue?vue&type=style&index=0&id=8f761d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f761d96",
  null
  
)

export default component.exports